import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from '@app/layouts/layout.component';
import { NgModule } from '@angular/core';
import { OktaCallbackComponent } from '@app/okta-callback.component';
import { AuthGuardService } from '@app/shared/auth-guard.service';
import { CognitoCallbackComponent } from '@app/cognito-callback.component';
import { CanDeactivateGuard } from '@app/shared/can-deactivate-guard.service';
import {HealthComponent} from "@app/health/health.component";
import { ReleaseNotesComponent } from './pages/release-notes/release-notes.component';

const routes: Routes = [
    // Lazy load the pages module and display its contents in the Layout component
    {
        path: '',
        component: LayoutComponent,
        canActivate: [ AuthGuardService ],
        loadChildren: () => import('./pages/pages.module' ).then(m => m.PagesModule)
    },
    {
        path: 'health',
        component: HealthComponent,
        loadChildren: () => import('./health/health.module').then(m => m.HealthModule)
    },
    {
        path: 'releasenotes',
        component: ReleaseNotesComponent,
        loadChildren: () => import('./pages/release-notes/release-notes.module').then(m => m.ReleaseNotesModule)
    },
    {
        path: 'login/callback',
        component: OktaCallbackComponent
    },

    {
        path: 'login/cognito-callback',
        component: CognitoCallbackComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            {
                scrollPositionRestoration: 'top',
                useHash: false
            })
        ],
    exports: [RouterModule],
    providers: [CanDeactivateGuard]
})
export class AppRoutingModule {

}
